// Pages
import LoginPage from "../pages/LoginPage";
import LogoutPage from "../pages/LogoutPage";
import RegistrationPage from "../pages/RegistrationPage";
import HomePage from "../pages/HomePage";

// Constants
import {
  ABOUT,
  APPLE_PAY_PAGE,
  DASHBOARD,
  DASHBOARD_SETTINGS,
  DASHBOARD_TICKET_TYPE,
  DASHBOARD_TICKET_TYPE_FORM_EDIT,
  DASHBOARD_TICKET_TYPE_FORM_NEW,
  DASHBOARD_TICKETS,
  DASHBOARD_TICKETS_FORM_EDIT,
  DASHBOARD_TICKETS_FORM_NEW,
  HOME,
  LOGIN,
  LOGOUT,
  PAYMENT_ERROR,
  PAYMENT_SUCCESS,
  PLAN_DETAILS,
  PRIVACY_POLICY,
  REGISTRATION,
} from "./constants";
import PlanDetailsPage from "../pages/MembershipPage/details";
import AboutPage from "../pages/About";
import PrivacyPolicyPage from "../pages/PrivacyPolicy";
import PaymentSuccessPage from "../pages/PaymentPage/success";
import PaymentErrorPage from "../pages/PaymentPage/error";
import DashboardPage from "../pages/DashboardPage";
import TicketTypePage from "../pages/DashboardPage/TicketTypePage";
import TicketTypeFormPage from "../pages/DashboardPage/TicketTypeFormPage";
import TicketsPage from "../pages/DashboardPage/TicketsPage";
import TicketsFormPage from "../pages/DashboardPage/TicketsFormPage";
import SettingsPage from "../pages/DashboardPage/SettingsPage";
import ApplePayPage from "../pages/ApplePayPage";

const routes = [
  {
    exact: true,
    path: HOME,
    element: <HomePage />,
    // elementForAuthenticated: <HomePage />,
  },
  {
    path: LOGIN,
    element: <LoginPage />,
    // redirectUrlForAuthenticated: HOME,
    // elementForAuthenticated: <HomePage />,
  },
  // {
  //   path: LOGIN_ADMIN,
  //   element: <LoginAdminPage />
  // },
  {
    path: LOGOUT,
    element: <LogoutPage />,
    isPrivate: true,
  },
  {
    path: DASHBOARD,
    element: <DashboardPage />,
    isPrivate: true,
    isEventAdmin: true
  },
  {
    path: DASHBOARD_TICKETS,
    element: <TicketsPage />,
    isPrivate: true,
    isEventAdmin: true
  },
  {
    path: DASHBOARD_TICKETS_FORM_NEW,
    element: <TicketsFormPage />,
    isPrivate: true,
    isEventAdmin: true
  },
  {
    path: DASHBOARD_TICKET_TYPE,
    element: <TicketTypePage />,
    isPrivate: true,
    isEventAdmin: true
  },
  {
    path: DASHBOARD_TICKETS_FORM_EDIT,
    element: <TicketsFormPage />,
    isPrivate: true,
    isEventAdmin: true
  },
  {
    path: DASHBOARD_TICKET_TYPE_FORM_NEW,
    element: <TicketTypeFormPage />,
    isPrivate: true,
    isEventAdmin: true
  },
  {
    path: DASHBOARD_TICKET_TYPE_FORM_EDIT,
    element: <TicketTypeFormPage />,
    isPrivate: true,
    isEventAdmin: true
  },
  {
    path: DASHBOARD_SETTINGS,
    element: <SettingsPage />,
    isPrivate: true,
    isEventAdmin: true
  },
  {
    path: APPLE_PAY_PAGE,
    element: <ApplePayPage />,
    isPrivate: false,
    isEventAdmin: false
  },
  // {
  //   path: REGISTRATION,
  //   element: <RegistrationPage />,
  //   // redirectUrlForAuthenticated: HOME,
  //   // elementForAuthenticated: <HomePage />,
  // },
  // {
  //   path: FORGOT_PASSWORD,
  //   element: <ForgotPasswordPage />,
  //   redirectUrlForAuthenticated: HOME,
  //   elementForAuthenticated: <HomePage />,
  // },
  // {
  //   path: DOCUMENT_CONFIRMATION,
  //   element: <DocumentConfirmationPage />,
  //   isPrivate: true,
  // },
  // {
  //   path: SEARCH,
  //   element: <SearchPage />,
  //   isPrivate: true,
  //   isVerifyRequired: true,
  // },
  // {
  //   path: SEARCH2,
  //   element: <Search2Page />,
  //   isPrivate: true,
  //   isVerifyRequired: true,
  // },
  // {
  //   path: EDIT_PROFILE2,
  //   element: <EditProfile2Page />,
  //   isPrivate: true,
  //   isVerifyRequired: true,
  // },
  // {
  //   path: MESSAGES,
  //   element: <MessagesPage />,
  //   isPrivate: true,
  //   isVerifyRequired: true,
  // },
  // {
  //   path: MESSAGES_ID,
  //   element: <MessagesPage />,
  //   isPrivate: true,
  //   isVerifyRequired: true,
  // },
  // {
  //   path: POSTS,
  //   element: <PostsPage />,
  //   isPrivate: true,
  //   isVerifyRequired: true,
  // },
  // {
  //   path: COMMENTS,
  //   element: <CommentsPage />,
  //   isPrivate: true,
  //   isVerifyRequired: true,
  // },
  // {
  //   path: NEW_POST,
  //   element: <NewPostPage />,
  //   isPrivate: true,
  //   isVerifyRequired: true,
  // },
  // {
  //   path: NOTIFICATIONS,
  //   element: <NotificationsPage />,
  //   isPrivate: true,
  //   isVerifyRequired: true,
  // },
  // {
  //   path: FAVORITES,
  //   element: <FavoritesPage />,
  //   isPrivate: true,
  //   isVerifyRequired: true,
  // },
  // {
  //   path: MY_PROFILE,
  //   element: <ProfilePage />,
  //   isPrivate: true,
  //   isVerifyRequired: true,
  // },
  // {
  //   path: MAP,
  //   element: <MapPage />,
  //   isPrivate: true,
  //   isVerifyRequired: true,
  // },
  // {
  //   path: PROFILE,
  //   element: <ProfilePage />,
  //   isPrivate: true,
  //   isVerifyRequired: true,
  // },
  // {
  //   exact: true,
  //   path: SETTINGS,
  //   element: <EditProfilePage />,
  //   isPrivate: true,
  //   isVerifyRequired: true,
  // },
  // {
  //   path: VERIFICATION,
  //   element: <VerificationPage />,
  //   isPrivate: true,
  //   isVerifyRequired: true,
  // },
  // {
  //   path: CHANGE_PASSWORD,
  //   element: <ChangePasswordPage />,
  //   isPrivate: true,
  //   isVerifyRequired: true,
  // },
  // {
  //   path: VEHICLES,
  //   element: <VehiclesPage />,
  //   isPrivate: true,
  //   isVerifyRequired: true,
  // },
  // {
  //   path: VEHICLE_REGISTRATION,
  //   element: <VehicleRegistrationPage />,
  //   isPrivate: true,
  //   isVerifyRequired: true,
  // },
  // {
  //   path: EDIT_VEHICLE,
  //   element: <EditVehiclePage />,
  //   isPrivate: true,
  //   isVerifyRequired: true,
  // },
  // {
  //   path: MEMBERSHIP,
  //   element: <MembershipPage />,
  //   isPrivate: true,
  //   isVerifyRequired: true,
  // },
  // {
  //   path: HISTORY,
  //   element: <HistoryPage />,
  //   isPrivate: true,
  //   isVerifyRequired: true,
  // },
  {
    path: ABOUT,
    element: <AboutPage />,
    isPrivate: false,
    isVerifyRequired: false,
  },
  {
    path: PRIVACY_POLICY,
    element: <PrivacyPolicyPage />,
    isPrivate: false,
    isVerifyRequired: false,
  },
  {
    path: PAYMENT_SUCCESS,
    element: <PaymentSuccessPage />,
    isPrivate: false,
    isVerifyRequired: false,
  },
  {
    path: PAYMENT_ERROR,
    element: <PaymentErrorPage />,
    isPrivate: false,
    isVerifyRequired: false,
  },
  {
    path: PLAN_DETAILS,
    element: <PlanDetailsPage />,
    isPrivate: false,
    isVerifyRequired: false,
  },
  // {
  //   path: SUBSCRIPTION_DETAILS,
  //   element: <SubscriptionDetailsPage />,
  //   isPrivate: true,
  //   isVerifyRequired: true,
  // },
  // {
  //   path: START_WASH,
  //   element: <StartWashPage />,
  //   isPrivate: true,
  //   isVerifyRequired: true,
  // },
  // {
  //   path: WASHES,
  //   element: <WashesPage />,
  //   isPrivate: true,
  //   isVerifyRequired: true,
  // },
  // {
  //   path: WASH_DETAILS,
  //   element: <WashDetailsPage />,
  //   isPrivate: true,
  //   isVerifyRequired: true,
  // },
  // {
  //   path: "*",
  //   element: <HomePage />,
  //   isPrivate: false,
  //   isVerifyRequired: false,
  // },
];

export default routes;
